import ExcelJS from "exceljs"

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FF556EE6" },
}

const HEADER_FONT = { bold: true, color: { argb: "FFFFFFFF" } }

const applyHeaderStyle = row => {
  row.eachCell(cell => {
    cell.font = HEADER_FONT
    cell.fill = HEADER_FILL
    cell.alignment = { vertical: "middle", horizontal: "center" }
  })
}

const triggerDownload = (buffer, fileName) => {
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = fileName
  a.click()
  URL.revokeObjectURL(url)
}

export const buildHidrometroTemplateWorkbook = () => {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = "Syskeeper"
  workbook.created = new Date()

  const sheet = workbook.addWorksheet("Lista de Hidrômetros")
  sheet.columns = [
    { header: "Código de Imóvel", key: "cdImovel", width: 22 },
    { header: "COMP", key: "comp", width: 16 },
    { header: "Nº HD", key: "nrHd", width: 18 },
  ]
  applyHeaderStyle(sheet.getRow(1))

  sheet.addRow({
    cdImovel: "1234567890",
    comp: "AP101B1",
    nrHd: "000001",
  })
  sheet.addRow({
    cdImovel: "1234567891",
    comp: "AP201",
    nrHd: "000002",
  })

  for (let i = 0; i < 8; i++) {
    sheet.addRow({})
  }

  const instructions = workbook.addWorksheet("Instruções")
  instructions.columns = [
    { header: "Campo", key: "campo", width: 22 },
    { header: "Descrição", key: "descricao", width: 80 },
  ]
  applyHeaderStyle(instructions.getRow(1))

  instructions.addRow({
    campo: "Código de Imóvel",
    descricao: "Opcional. Identificador do imóvel. Pode ficar em branco.",
  })
  instructions.addRow({
    campo: "COMP",
    descricao:
      "Obrigatório. Com bloco: AP{apto}B{bloco} (ex.: AP101B1 → APT1 101 / BLOCO 1). Sem bloco: AP{apto} (ex.: AP201 → APTO 201).",
  })
  instructions.addRow({
    campo: "Nº HD",
    descricao: "Obrigatório. Número do hidrômetro/medidor.",
  })
  instructions.addRow({
    campo: "MACRO",
    descricao:
      "Linhas com COMP igual a MACRO são ignoradas na importação.",
  })
  instructions.addRow({
    campo: "Aba de dados",
    descricao:
      "Preencha somente a aba Lista de Hidrômetros. Apague as linhas de exemplo antes de importar.",
  })

  return workbook
}

export const downloadHidrometroTemplate = async () => {
  const workbook = buildHidrometroTemplateWorkbook()
  const buffer = await workbook.xlsx.writeBuffer()
  triggerDownload(buffer, "planilha-modelo-imoveis.xlsx")
}
